import { BaseThemeProps } from './BaseThemeProps';

export const baseTheme: BaseThemeProps = {
  fonts: {
    regular: 'OpenSans Regular',
    bold: 'OpenSans Bold',
    semiBold: 'OpenSans Semi Bold',
    extraBold: 'OpenSans Extra Bold',
    italic: 'OpenSans Italic',
    semiBoldItalic: 'OpenSans Semi Bold Italic',
    light: 'OpenSans Light',
    extraBoldItalic: 'OpenSans Extra Bold Italic',
    helveticaNeueRegular: 'Helvetica Neue Regular',
    helveticaNeueBold: 'Helvetica Neue Bold'
  },
  colors: {
    gold: '#EC9F24',
    blueOne: '#3992C6',
    blueTwo: '#009FD3',
    blueThree: '#1A91CF',
    blue04: '#7AC7E2',
    blue08: '#07A1D4',
    blue14: '#014667',
    blue12: '#01658D',
    darkBlue: '#015F94',
    lightGrey: '#CFCFCD',
    lightGrey2: '#CDC3B4',
    mediumGrey: '#58585A',
    mediumGrey2: '#747474',
    mediumGrey3: '#6386A0',
    darkGrey: '#3C3C3E',
    darkGrey2: '#58585A',
    darkGrey3: '#44546A',
    greyDarkDisable: '#ACACAD',
    red: '#AE2824',
    orange: '#F57E20',
    darkerBlue: '#005980',
    darkestBlue: '#142A56',
    lighterGrey: '#EAEBEC',
    bgGrey: '#E6E6EE',
    bgGrey2: '#F6F8FA',
    green: '#39C671',
    graphic02: '#ECE7F2',
    graphic03: '#D0D1E6',
    graphic04: '#A6BDDB',
    graphic05: '#74A9CF',
    graphic06: '#3690C0',
    graphic07: '#0570B0',
    graphic08: '#045A8D',
    graphicGreen: '#B0DB72',
    graphicRed: '#BD2038',
    graphicYellow: '#F1D665',
    lightBlue: '#CCDEE6',
    lightBlue2: '#E5F5FB',
    lightBlue3: '#8697A7',
    explorerTableHeaderColor: '#EBF7FC',
    lightBlueBackground: 'rgba(0, 89, 128, 0.2)',
    borderGrey: 'rgba(88, 88, 90, 0.75)',
    greyBackground: 'rgb(247, 247, 252)',
    white: '#FFFFFF',
    black: '#000000',
    smoky: '#59595b',
    stormGrey: '#797d89',
    grey7: '#8C8C8C',
    grey8: '#595959',
    grey9: 'rgba(230, 230, 238, 0.2)',
    greenDark: '#1F6F78',
    greenMedium: '#118A7E',
    greenExplorer: '#3BAEA0',
    lightGreenExplorer: '#93E4C1',
    lightGreyBackground: '#E5EDF2',
    tableHeaderBlue: '#DDE8EE',
    explorerBackground: '#f6f8fa',
    explorerHomeHeader: '#EEF2F4',
    ghostWhite: '#F3F3F7',
    panache: '#EFF8F4'
  },
  schemes: {
    blue01: [
      '#D6E6ED',
      '#B6DBE9',
      '#98D1E6',
      '#7AC7E2',
      '#5DBEDF',
      '#41B5DB',
      '#26ACD8',
      '#07A1D4',
      '#0192C3',
      '#0181AE',
      '#01739E',
      '#01658D',
      '#01567A',
      '#014667',
      '#013856'
    ],
    greenBlue01: [
      '#173D36',
      '#1C5952',
      '#118A7E',
      '#3BAEA0',
      '#49BA9F',
      '#66C9AB',
      '#93E4C1',
      '#ABF3D4',
      '#C0FFE4',
      '#DFFFF1',
      '#1F6F78',
      '#288A95',
      '#2E9FAC',
      '#33B8C6',
      '#47C2CF',
      '#63CBD7',
      '#7AD2DC',
      '#99DDE5',
      '#AFE4EA',
      '#C6ECF0'
    ]
  },
  shadow: {
    smallShadow:
      '0px 33px 80px rgba(0, 0, 0, 0.12), 0px 20.8247px 21.281px rgba(0, 0, 0, 0.0712147), 0px 4.70689px 7.10974px rgba(0, 0, 0, 0.0479366)',
    mediumShadow:
      '0px 9px 19px rgba(0, 0, 0, 0.05), 0px 6.03094px 10.3972px rgba(0, 0, 0, 0.025), 0px 2.15775px 3.40155px rgba(0, 0, 0, 0.0167612)',
    mediumShadowLight:
      '0px 9px 19px rgba(0, 0, 0, 0.03), 0px 6.03094px 10.3972px rgba(0, 0, 0, 0.015), 0px 2.15775px 3.40155px rgba(0, 0, 0, 0.005)',
    bigShadow:
      '0px 100px 74px rgba(0, 0, 0, 0.05), 0px 41.7776px 30.9154px rgba(0, 0, 0, 0.04), 0px 22.3363px 16.5289px rgba(0, 0, 0, 0.04), 0px 12.5216px 9.26595px rgba(0, 0, 0, 0.03), 0px 6.6501px 4.92108px rgba(0, 0, 0, 0.03), 0px 2.76726px 2.04777px rgba(0, 0, 0, 0.02)',
    xs: '0px 1px 2px rgba(0, 0, 0, 0.05)',
    sm: '0px 1px 2px rgba(0, 0, 0, 0.06), 0px 1px 3px rgba(0, 0, 0, 0.1)',
    md: '0px 2px 4px -1px rgba(0, 0, 0, 0.06), 0px 4px 6px -1px rgba(0, 0, 0, 0.1)',
    lg: '0px 4px 6px -2px rgba(0, 0, 0, 0.05), 0px 10px 15px -3px rgba(0, 0, 0, 0.1)',
    xl: '0px 10px 10px -5px rgba(0, 0, 0, 0.04), 0px 20px 25px -5px rgba(0, 0, 0, 0.1)',
    '2xl': '0px 25px 50px -12px rgba(0, 0, 0, 0.25)',
    darkLg:
      '0px 100px 74px rgba(0, 0, 0, 0.05), 0px 40px 30px rgba(0, 0, 0, 0.04), 0px 22px 16px rgba(0, 0, 0, 0.04), 0px 13px 10px rgba(0, 0, 0, 0.03), 0px 7px 5px rgba(0, 0, 0, 0.03), 0px 3px 2px rgba(0, 0, 0, 0.02)',
    outline: ' 0px 0px 0px 3px rgba(63, 153, 225, 0.6)',
    inner: 'inset 0px 2px 4px rgba(0, 0, 0, 0.06)',
    kbdInner: 'inset 0px -2px 0px #E2E8F0'
  },
  transition: 'all 0.1s'
};

export default baseTheme;
